import pathfinder from '@fiverr-private/pathfinder';

export const FAQ_ITEMS = [
    {
        key: '1',
        image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/1a4d7ade60dc73992853a92a62a35207-1762334564784/brand-lohp-b17-faqs-1.png',
        imageMobile:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/da0c570ad161d4cbe8ed5b74302af142-1762336790567/brand-lohp-b17-faqs-1-mobile.png',
        question: 'v17.faqs.items.1.question',
        answer: 'v17.faqs.items.1.answer',
        url: 'https://answers.fiverr.com/',
    },
    {
        key: '2',
        image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/1a4d7ade60dc73992853a92a62a35207-1762334564778/brand-lohp-b17-faqs-2.png',
        imageMobile:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7cabeebde9f1dedeb0d22d42461fd027-1762336692853/brand-lohp-b17-faqs-2-mobile.png',
        question: 'v17.faqs.items.2.question',
        answer: 'v17.faqs.items.2.answer',
        positionTop: true,
        url: pathfinder('content_pages_page', { page_slug: 'how-fiverr-works' }),
    },
    {
        key: '3',
        image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/1a4d7ade60dc73992853a92a62a35207-1762334564789/brand-lohp-b17-faqs-3.png',
        imageMobile:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7cabeebde9f1dedeb0d22d42461fd027-1762336692857/brand-lohp-b17-faqs-3-mobile.png',
        question: 'v17.faqs.items.3.question',
        answer: 'v17.faqs.items.3.answer',
        url: pathfinder('education_hub_render'),
    },
];
